var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"dir":"ltr"}},[_c('p',{staticClass:"mb-1"},[_vm._v("نقشه")]),_c('div',{attrs:{"id":"mapcontainer"}})])}]

export { render, staticRenderFns }